angular
    .module('eficienciaFiscalModule')
    .filter('cest', () => {
        return (input) => {
            if (input) {
                return input.replace(/(\d{2})(\d{3})(\d+)/, '$1.$2.$3')
            }
        }
    })
